import { Component, OnInit } from '@angular/core';
import { DynamicDialogComponent, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { TokenService } from '../../services/token.service';
import { Store } from '@ngrx/store';
import { selectUnidadeLista } from 'src/app/store/unidade/unidade.selectors';
import { map } from 'rxjs';
import { NotifyService } from 'src/app/shared/services/notify.service';

@Component({
  selector: 'app-choose-unit-modal',
  templateUrl: './choose-unit-modal.component.html',
  styleUrls: ['./choose-unit-modal.component.scss']
})
export class ChooseUnitModalComponent implements OnInit {
  units!: any[]; 
  //units$ = this.store.select(selectUnidadeLista).pipe(map((lista: any[]) => lista.filter( item => item.isActive ) ))
  credentials!: {email: string, password: string};
  
  constructor(
    private dynamicDialogConfig: DynamicDialogConfig, 
    private dynamicDialogRef: DynamicDialogRef,
    private authService: AuthenticationService,
    private router: Router,
    private store: Store,
    private notifyService: NotifyService
    ) {

  }

  ngOnInit(): void {
    this.units = this.dynamicDialogConfig.data.units;
    this.credentials = this.dynamicDialogConfig.data.credentials;
  }

  selectUnit(id: string) {
    this.authService.authPOST({
      email: this.credentials.email, 
      password: this.credentials.password,
      unitId: id
    }).subscribe({
        next: (response: any) => {
          localStorage.setItem('access_token', response.accessToken);
          localStorage.setItem('refresh_token', response.refreshToken);
          localStorage.setItem('userId', response.userId);
          localStorage.setItem('realm', response.realm);
          localStorage.setItem('clientId', response.clientId);
          localStorage.setItem('unitId', response.unitId);
        this.dynamicDialogRef.close(response);
      },
      error: (err: any) => {
        this.dynamicDialogRef.close(null);
        this.router.navigate(['/login']).then(() => {
          this.notifyService.emitError('Credenciais inválidas');
        });
        }
      })
  }
}
